import React, { useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'clsx';

import { isSignedUrl, validateSourceCache } from '@/modules/common/helpers/videoCache';
import { updateResourcesStartedAction } from '@/modules/common/redux/slices/common';

import styles from './Image.module.scss';

type ImageProps = {
  alt?: string;
  cover?: boolean;
  height: number | string;
  lazyLoading?: boolean;
  src: string;
  width: number | string;
  className?: string;
};

function Image$({ alt = 'img', cover = false, lazyLoading = true, width, height, src, className }: ImageProps) {
  const dispatch = useDispatch();
  const [isError, setIsError] = useState(false);
  const [src$, setSrc$] = useState(src);

  useLayoutEffect(() => {
    validateSourceCache(src, (params) => {
      dispatch(updateResourcesStartedAction(params));
    });

    if (src !== src$) {
      setSrc$(src);
      if (isSignedUrl(src) && isError) {
        setIsError(false);
      }
    }
  }, [src, dispatch, isError, src$]);

  return (
    <img
      className={classNames(styles.Image, className, {
        [styles.Image___cover]: cover,
        [styles.Image___hidden]: isError,
      })}
      loading={lazyLoading && !isSignedUrl(src$) ? 'lazy' : undefined}
      alt={alt}
      src={src$}
      width={width}
      height={height}
      onError={() => setIsError(true)}
    />
  );
}

export default Image$;
